/**
 * @file upload.api.js
 * @module UploadAPI
 * @description HTTP API wrapper for file upload endpoints. Methods return Axios promises.
 */

import { axiosInstance } from "./axios";
import { ENV } from "../config/env";
export const UploadAPI = {
    /**
     * Upload a file to the server or external upload service depending on environment.
     * @param {FormData|Object} file - FormData or payload containing the file to upload.
     * @param {string} [queryString=""] - Optional query string appended to the upload URL.
     * @param {string} [token=""] - Optional authentication token (when required).
     * @returns {Promise} Axios promise resolving to upload response.
     */
    uploadFile: (file, queryString = "", token = "") => {
        if (ENV === "production") {
            return axiosInstance(`Bearer ${token}`).post(`https://api.upload.io/v2/accounts/FW25b8h/uploads/form_data${queryString ? `?${queryString}` : ""}`, file);
        } else {
            let headers = { 'Content-Type': 'multipart/form-data' }
            return axiosInstance(token).post(`/upload${queryString ? `?${queryString}` : ""}`, file, { headers: headers });
        }
    }
}

